import React, { useState, useEffect } from "react";
import { makeStore } from "./redux/store.js";
import { PersistGate } from "redux-persist/integration/react";
import { ThemeProvider } from "styled-components";
import { Provider } from "react-redux";
import { theme } from "./Utility/Theme.js";
import MainRouting from "./Routing/MainRouting";
import LocalLang from "./Utility/Method/LocalLang";
import { DefaultLang } from "./Utility/DefaultLang";
import LocalToken from "./Utility/Method/LocalToken";
import LocalContext from "./Context/LocalContetxt";
import LocalConfig from "./Utility/Method/LocalConfig";
import { v4 as uuidv4 } from "uuid";
import Cookies from "js-cookie";
import jMoment from "moment-jalaali";
import "typeface-lalezar";
import "./App.scss";

const store = makeStore();
jMoment.loadPersian({ dialect: "persian-modern", usePersianDigits: true });

export function getGuid() {
  return Cookies.get("lingo_guid");
}

function App(props) {
  const localConfigs = LocalConfig.Get();
  const [lang, setLang] = useState(LocalLang.Get() || DefaultLang);
  const [hasToken, setHasToken] = useState(
    LocalToken.Get("tokenObj") ? true : false
  );
  const [config, setConfig] = useState(localConfigs ? localConfigs : null);

  useEffect(() => {
    let guid = Cookies.get("lingo_guid");
    if (typeof guid === "undefined") {
      Cookies.set("lingo_guid", uuidv4());
    }
  }, []);

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={store.__persistor}>
        <LocalContext.Provider
          value={{
            lang,
            setLang,
            hasToken,
            setHasToken,
            config,
            setConfig,
          }}
        >
          <ThemeProvider theme={theme}>
            <MainRouting {...props} />
          </ThemeProvider>
        </LocalContext.Provider>
      </PersistGate>
    </Provider>
  );
}

export default App;
